import useAuth from "./useAuth";
import keycloakInstance from "@/initKeycloak";
import { isDeskToken } from "./deskRole";

/**
 * May this user publish to the Newsquawk library?
 *
 * The rule itself lives in `deskRole.ts` — see there for why the client, not
 * just the role, decides. This is the React wrapper.
 *
 * Kept separate from `useHasInternalNewsquawkUserRole()` on purpose: that hook
 * feeds `useAccessControl.isInternalUser` and a dozen widget call sites, so
 * bending it to carry a write permission would quietly change who sees
 * internal widgets and firehose sources.
 *
 * Presentation only — the server enforces the same rule independently, so this
 * is not the security boundary.
 */
export const useIsDeskUser = (): boolean => {
  const { authenticated, tokenParsed } = useAuth();

  if (!authenticated) return false;
  return isDeskToken(keycloakInstance.clientId, tokenParsed);
};
